import { render } from "./CancelButton.vue?vue&type=template&id=cbcc6924"
import script from "./CancelButton.vue?vue&type=script&lang=js"
export * from "./CancelButton.vue?vue&type=script&lang=js"

import exportComponent from "/Users/valdisaglonietis/PhpstormProjects/news_site/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"CancelButton.vue"]])

export default __exports__